export const GET_COURSE_REQUEST = "GET_COURSE_REQUEST";
export const GET_COURSE_SUCCESS = "GET_COURSE_SUCCESS";
export const GET_COURSE_FALIURE = "GET_COURSE_FALIURE";